export function findKeyByValue(obj, value) {
  return Object.keys(obj).find(key => obj[key] === value) || null;
}
